import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { formatPrice } from '@/lib/format'

interface PriceProps {
    price: number
    compareAt?: number | null
    size?: 'default' | 'lg'
    className?: string
}

const Price: FC<PriceProps> = ({ price, compareAt, size = 'default', className }): ReactNode => {
    const onSale = typeof compareAt === 'number' && compareAt > price

    return (
        <p className={cn('flex items-baseline gap-2', className)}>
            {onSale && (
                <span className='sr-only'>
                    Sale price
                </span>
            )}

            <span
                className={cn(
                    'font-heading font-extrabold tabular-nums',
                    size === 'lg' ? 'text-3xl' : 'text-lg',
                    onSale && 'text-tide'
                )}
            >
                {formatPrice(price)}
            </span>

            {onSale && (
                <>
                    <span className='sr-only'>
                        Regular price
                    </span>

                    <s className={cn('text-muted-foreground tabular-nums', size === 'lg' ? 'text-lg' : 'text-sm')}>
                        {formatPrice(compareAt)}
                    </s>
                </>
            )}
        </p>
    )
}

export default Price
